export class BaseConnectorStrategy {
    getSigner() {
        return this.activeSigner;
    }
    getSigners() {
        return this.signers;
    }
    async onSessionChange(session) {
        await this.dAppConnector.onSessionConnected(session);
        this.signers = this.dAppConnector.getSigners();
        this.activeSigner = this.signers[0] || null;
        await this.selectAccount();
        await this.dAppConnector.client.ping({
            topic: this.dAppConnector.session.topic
        });
    }
    onSessionDisconnect(callback) {
        this.dAppConnector.client.on("session_delete", callback);
    }
    onSessionExpire(callback) {
        this.dAppConnector.client.on("session_expire", callback);
    }
}
